import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintWorkflow } from './';

/**
 * @component {kat-blueprint-workflow-focus} KatBlueprintWorkflowFocus Component used to place and filter components within the focus section.
 * @slot default Blueprint content for focus section.
 */
@register(KatBlueprintWorkflow.slotMapping.focus.name)
export class KatBlueprintWorkflowFocus extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintWorkflow.slotMapping.focus.name,
      KatBlueprintWorkflow.slotMapping.focus.allowed
    );
  }
}
